import { connect } from "react-redux";
import React, { Component } from "react";
import FicheClient from "./FicheClient";

class FicheClientPage extends Component {
  constructor(props) {
    super(props);
    let { uen, year } = this.props.match.params;

    this.state = { organizationUen: uen, year: year };
  }

  render() {
    return (
      <div className={`page-content`}>
        <FicheClient uen={this.state.organizationUen} year={this.state.year} />
      </div>
    );
  }
}
const mapStateToProps = state => ({});
export default connect(mapStateToProps)(FicheClientPage);



// WEBPACK FOOTER //
// ./src/components/FicheClient/FicheClientPage.js